module.exports = __webpack_public_path__ + "img/trainings-768_new.0c48d2f1.jpg";